export default "__VITE_PUBLIC_ASSET__a431f70c__"